module.exports = __webpack_public_path__ + "static/img/img.7e5dbc3d.png";